module.exports = __webpack_public_path__ + "static/img/service (1).3b96b85a.jpg";